// Wave 46 · Soundbox — mounted once at Layout level (see App.js) so live voice
// announcements (new demands, bids, deal locks, orders, payments, escrow) play on
// every page for logged-in users, not just while sitting on the ATC floor.
// Renders nothing — it's a pure side-effect bridge around useSoundboxEvents.
import useSoundboxEvents from '../../hooks/useSoundboxEvents';

export default function SoundboxAnnouncer() {
  useSoundboxEvents();
  return null;
}
